import React from 'react';
import { Helmet } from 'react-helmet';
import './DirectionsPage.css';

const DirectionsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Directions - Michael and Ashlynn's Wedding</title>
        <meta name="description" content="Directions and parking information for our wedding venue" />
      </Helmet>

            <main className="page directions-page">
        <div className="directions-container">
          <h1>Directions & Parking</h1>

          <div className="directions-content">
            <div className="map-section">
              <img
                src="/map.png"
                alt="Map to wedding venue"
                className="venue-map"
              />
            </div>

            <div className="parking-info">
              <h2>Parking Information</h2>
              <p>
                Free valet available on the driveway west of the venue starting at 2:30 PM.
                Free street parking on Wells St and Prospect Ave all day.
              </p>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default DirectionsPage;
